import store from '../store.js';
import Api from './Api';

function getBaseURL()
{
    return process.env.CUSTOMER_PROFILE_API_ENDPOINT;
}

export default {
    GetProfile() {
        var baseUrl = getBaseURL();
        return Api.get(baseUrl).then((response => {
            store.commit("SetProfile", response.data[0]);
            return response;
        }));
    },
    UpdateProfile(profile) {
        var url = process.env.CUSTOMER_PROFILE_API_ENDPOINT + "&key=" + profile.Oid;;

        var payload = {
            "Phone": profile.Phone,
            "Mobile": profile.Mobile,
            "Email": profile.Email
        };

        return Api.put(url, payload);
    },
    SetPrimaryShipping(profile, companyOid, addressOid) {

        var url = process.env.CUSTOMER_PROFILE_API_ENDPOINT + "&key=" + profile.Oid;;

        var payload = {
            // Company:{
            //     Operation: "Update",
            //     Value: {
            //         PrimaryShippingAddress: {
            //             Operation: "Link",
            //             Value: addressOid
            //         }
            //     }
            // },
            Companies:[
                {
                    Operation: "Update",
                    Value: {
                      Key : companyOid,
                      Update : {
                        PrimaryShippingAddress: {
                            Operation: "Link",
                            Value: addressOid
                        }
                      }
                    }
                }
            ]
        };

        return Api.put(url, payload).then(r => {
            store.commit("SetProfile", r.data.Record);
            return r;
        });
    },
    GetAddress(key) {
        var url = process.env.CUSTOMER_ADDRESS_API_ENDPOINT + "&key=" + key;
        return Api.get(url);
    },
    SaveAddress(address) {
        var url = process.env.CUSTOMER_ADDRESS_API_ENDPOINT;

        var payload = {
            "AttentionTo": address.AttentionTo,
            "Line1": address.Line1,
            "Line2": address.Line2,
            "Line3": address.Line3,
            "City": address.City,
            "State": address.State,
            "Postcode":address.Postcode,
            "Country": address.Country
        };

        if(address.Oid) {
            url = url + "&key=" + address.Oid;
            return Api.put(url, payload);
        }
        else
        {
            payload.Company = { "Operation": "Link", "Value": store.state.auth.company.Oid };
            return Api.post(url, payload);
        }  
    },
    ChangePassword(oldPassword, newPassword, success, fail) {
        
        var payload = {
            OldPassword: oldPassword,
            NewPassword: newPassword
        };

        return Api.post(process.env.CHANGE_PASSWORD_WORKFLOW_ENDPOINT, payload);
    }
}


// WEBPACK FOOTER //
// ./src/services/ProfileService.js